export const IMAGE_URL = 'https://img2.traum-ferienwohnungen.de/region/'

export const IMAGE_SIZES = {
    largeWide: 'grid-large-wide',
    large: 'grid-large',
    medium: 'grid-medium',
    small: 'grid-small',
}

export const USER_TYPE = {
    tourist: 'tourist',
    customer: 'customer',
}

export enum SITE_NAME {
    SRL_PAGE_LIST_VIEW = 'site_name_srl_page_list_view',
    SRL_PAGE_MAP_VIEW = 'karte',
    SRL_PAGE_TILE_VIEW = 'site_name_srl_page_tile_view',
    REGION_LANDING_PAGE = 'site_name_region_landing_page',
    BOOKING_KIT_PAGE = 'site_name_booking_kit_page',
}

export const PAGE_SYSTEM = 'is_guest_website_frontend'

export const WORLD_REGION_NODE_ID = 1

export enum AB_KEY {
    IRON_MAN = 'irmn',
    PDP_PAGE = 'pdpe',
    RESULTS_PAGE = 'srlv',
    SEARCH = 'flex',
    DIRECT_BOOKING_PAGE = 'dbpv',
    PDP_TO_INQUIRY_FLOW = 'lapd',
    CHECKOUT_FIELDS = 'nypd',
    RECENTLY_VIEWED = 'rvli',
    BINDING_BOOKING_PAGE = 'bbpv',
    DIRECT_INQUIRY_BUTTON = 'dibu',
    SEARCH_PARAM_RETENTION = 'spre',
    APP_BANNERS = 'pdpb',
    DISABLE_CALL_BUTTON = 'dcbv',
    DIRECT_BOOKING_VALIDATION = 'dbvv',
    IRONMAN_USE_SCORE_FIELDS = 'isce',
    IRONMAN_SCORE_FIELD = 'isfv',
    ZENDESK_VIEW = 'chat',
    GALLERY_VIEW = 'gvak',
    LEAD_SHARING = 'lsav',
    CHECKOUT_DESIGN = 'chdv',
    LEAD_SHARING_ACTIVATE_POPUP = 'lspa',
    HOME_PAGE_REVAMP = 'hprv',
    CHECKOUT_NAVBAR = 'chnv',
    REGION_AUTO_SUGGEST = 'ssap',
    HOME_PAGE_WIDGET_CHANGES = 'hpwc',
    CHECKOUT_MERGER = 'chme',
    SUPERFAST_RESPONDER_TAG = 'sfrt',
    DISCLAIMER_MESSAGE_VISIBLE = 'dmvv',
    PDP_RECOMMENDATIONS = 'pdpr',
    POPULAR_SEARCHES = 'hpps',
    PDP_RECOMMENDATION = 'pdps',
    LEAD_SHARING_HEADING = 'lshc',
    LEAD_SHARING_DISTANCE_VISIBLE = 'lsdk',
    FORMATTED_PRICE = 'cent',
    SRL_GRID_VIEW = 'grid',
    SLASHER_PRICE = 'slsh',
    VIRTUAL_TOUR_PDP = 'vtpd',
    BOOKING_BANNER_SRL = 'bbsr',
    EXPERIENCES_SECTION = 'expe',
    EMBEDDED_LEAD_SHARING = 'elsw',
    RECENT_SEARCHES = 'rsch',
    HIDDEN_GEM_CAROUSEL = 'hgck',
}

export enum AB_VARIANT_VERSION {
    ZERO = 0,
    ONE = 1,
    TWO = 2,
}

export const LOCALES = {
    DE_AT: 'de-AT',
    DE_CH: 'de-CH',
    DE_DE: 'de-DE',
    EN_GB: 'en-GB',
    EN_US: 'en-US',
    ES_ES: 'es-ES',
    FR_FR: 'fr-FR',
    HR_HR: 'hr-HR',
    IT_IT: 'it-IT',
    NL_NL: 'nl-NL',
} as const
